import { render } from "./SingleGallerySection.vue?vue&type=template&id=6e762b93"
import script from "./SingleGallerySection.vue?vue&type=script&lang=js"
export * from "./SingleGallerySection.vue?vue&type=script&lang=js"

import "./SingleGallerySection.vue?vue&type=style&index=0&id=6e762b93&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__